/**
 * Created by 胡子哥 on 2021/09/12.
 */
import {$http} from '../common/axios.js';
import {_CONFIG} from '../config/config.js';
class ServicesGlobal {
    constructor() {
        this.path = {
            api: _CONFIG.apiPath+"/boss",
            www: _CONFIG.apiPath+"/www",
            apiPublic:_CONFIG.apiPath+"/www/public",
        }
    }

    postParams(obj) {
        let params = new URLSearchParams();
        for (let key in obj) {
            params.append(key, obj[key]);
        }
        return params;
    }

    //获取验证码
    getImgCode(data){
        return $http.get(`${this.path.apiPublic}/imgCaptcha`,{params:data})
            .then(function (response) {
                return response.data;
            });
    }
    //获取验证码
    getFileLists(data){
        return $http.get(`${this.path.api}/fileLists`,{params:data})
            .then(function (response) {
                return response.data;
            });
    }

    upFile(data = {}) {
        let params = this.postParams(data);
        return $http.post(`${this.path.api}/articleClass/upFile`, params)
            .then(function (response) {
                return response.data;
            });
    }

    getQrCode(url){
        return $http.get(url)
            .then(function (response) {
                return response.data;
            });
    }

    getTableFields(data={}){
        return $http.get(`${this.path.api}/tools/getTableFields`,{params:data})
            .then(function (response) {
                return response.data;
            });
    }

    // router /boss/team/exportExcel
    exportExcel(routerName,data) {
        let exportMap = {
            "activity_order": "/activityOrder/exportExcel",
            "team": "/team/exportExcel",
            "employee": "/employee/exportExcel",
            "device": "/device/exportExcel",
            "device_one": "/deviceOne/exportExcel",
            "device_two": "/deviceTwo/exportExcel",
            "device_three": "/deviceThree/exportExcel",
            "device_source": "/deviceSource/exportExcel",
        }
        let router = exportMap[routerName]
        return $http.get(`${this.path.api}${router}`,{params:data})
            .then(function (response) {
                return response.data;
            });
    }
    getQrCodeE(data={}){
        let params = this.postParams(data);
        return $http.post(`${this.path.api}/createEWM`,params)
            .then(function (response) {
                return response.data;
            });
    }
    departmentShow(data={}){
        return $http.get(`${this.path.api}/departmentShow`,{params:data})
            .then(function (response) {
                return response.data;
            });
    }
    manufacturerShow(data={}){
        return $http.get(`${this.path.api}/manufacturerShow`,{params:data})
            .then(function (response) {
                return response.data;
            });
    }
}

export {
    ServicesGlobal
};